import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/providers/auth.service';

@Component({
  selector: 'app-view-receipt-no-auth',
  templateUrl: './view-receipt-no-auth.component.html',
  styleUrls: ['./view-receipt-no-auth.component.scss']
})
export class ViewReceiptNoAuthComponent implements OnInit {
public view_invoice :boolean = false;
  constructor(    private authService: AuthService) {
    this.view_invoice = window.location.href.split("/").indexOf("vi") != -1;
   }

  ngOnInit(): void {
    this.authService.getSecurityCheck().subscribe((res: any) => {
      if (res?.psi) {
        this.addScriptElement(res?.psiUrl)
      }   
    })
  }

  addScriptElement(psiUrl: string) {
    if (!psiUrl) return
    const node = document.createElement('script');
    node.id = "mem-id";// creates the script tag
    node.src = psiUrl; // sets the source (insert url in between quotes)
    node.type = "text/javascript"  // set the script type
    node.async = true; // makes script run asynchronously
    node.defer = true; // prevents script from blocking HTML parsing
    node.referrerPolicy = "strict-origin-when-cross-origin"; // limits how much referrer information is sent to Memyco servers
    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node);
    const mem = document.getElementById("mem-id")
    console.log("mem added", mem)
  }

}
